import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Button, Spacer, SharedModal } from './'

const ContentRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
`

const ButtonsBox = styled.div`
  flex-shrink: 0;

  @media (max-width: 800px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    margin: 0;
  }
`

const BodyText = styled.div`
  color: ${p => p.theme.mediumGray};
  font-size: 18px;
  line-height: 33px;
  flex: 1;
`

class ModalConfirmation extends Component {
  static propTypes = {
    bodyText: PropTypes.string,
    isModalOpen: PropTypes.bool,
    title: PropTypes.string,
    toggleModal: PropTypes.func,
  }

  render() {
    const { bodyText, isModalOpen, toggleModal, title = 'Delete This Information' } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={toggleModal}>
        <Spacer space='15px' />
        <ContentRow>
          <BodyText>{bodyText}</BodyText>
          <ButtonsBox>
            <Button primary label='Got it!' onClick={toggleModal} width='118px' />
          </ButtonsBox>
        </ContentRow>
      </SharedModal>
    )
  }
}

export default ModalConfirmation
